import React from "react";
import { Link } from "react-router-dom";
import styles from "./CustomButton.module.css";

type Variant = "filled" | "outline";
type Size = "small" | "medium" | "large";

export interface CustomButtonProps {
  text: string;
  to?: string;
  variant?: Variant;
  size?: Size;
  onClick?: () => void;
  className?: string;
  asChild?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  to,
  variant = "filled",
  size = "medium",
  onClick,
  className = "",
  asChild = false,
}) => {
  const classes = [styles.buttonBase, styles[variant], styles[size], className]
    .filter(Boolean)
    .join(" ");

  if (to && !asChild) {
    return (
      <Link to={to} className={classes} onClick={onClick} aria-label={text}>
        {text}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      aria-label={text}
    >
      {text}
    </button>
  );
};

export default CustomButton;
